/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4309beb61c50fd8fa94e4cab5d1416d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { FeedbackLogo } from './logo';
export { FeedbackLogoCS } from './logo-cs';
export { FeedbackIcon } from './icon';
